import {
  TRANSACTIONS_LIST_REQUEST,
  TRANSACTIONS_LIST_RESPONSE
} from "./types";

export const transactionsListRequest = (payload) => ({
  type: TRANSACTIONS_LIST_REQUEST,
  payload
});

export const transactionsListResponse = (payload) => ({
  type: TRANSACTIONS_LIST_RESPONSE,
  payload
});
